module.exports = __webpack_public_path__ + "img/demo.0845eba5.png";